// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { fontConfig } from "@conklin/XDL/PreStyle/typography";
import { locationSearchFormStyles } from "@insite/content-library/Components/LocationSearchForm";
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { css } from "styled-components";

const fontStyles: TypographyPresentationProps = {
    color: "text.link",
    variant: "h5",
    size: 16,
    css: css`
        margin-bottom: 0;
    `,
};

locationSearchFormStyles.searchResultDisplayNumberGridItem = {
    ...locationSearchFormStyles.searchResultDisplayNumberGridItem,
    css: css`
        justify-content: center;
        align-items: center;
    `,
};

locationSearchFormStyles.locationDisplayNumberText = {
    ...fontStyles,
};

locationSearchFormStyles.locationNameLink = {
    typographyProps: {
        ...fontStyles,
        ellipsis: true,
    },
};

locationSearchFormStyles.locationGoogleMapsDirectionLink = locationSearchFormStyles.searchResultPhoneLink = {
    typographyProps: {
        ...fontStyles,
    },
};

locationSearchFormStyles.locationDistanceDisplayText = {
    ...fontStyles,
    weight: fontConfig.weight.regular,
};

locationSearchFormStyles.searchResultDistanceGridItem = {
    ...locationSearchFormStyles.searchResultDistanceGridItem,
    width: [6, 4, 4, 4, 4],
    css: css`
        align-items: center;
    `,
};

locationSearchFormStyles.searchResultGoogleMapsDirectionLinkGridItem = {
    ...locationSearchFormStyles.searchResultGoogleMapsDirectionLinkGridItem,
    width: [4, 4, 2, 2, 2],
    css: css`
        align-items: center;
    `,
};

locationSearchFormStyles.distanceUnitOfMeasureRadioGroup = {
    ...locationSearchFormStyles.distanceUnitOfMeasureRadioGroup,
    css: css`
        display: inline-block;
        width: 100%;
        flex-direction: row;
        text-align: right;
        & > div {
            display: inline-flex;
        }
        & > [class^="RadioStyle"]:first-of-type {
            margin-right: 10px;
        }
        & > ${TypographyStyle as any} {
            padding: 0;
            margin-bottom: 0;
        }
    `,
};

locationSearchFormStyles.locationContentLink = {
    css: css`
        ${TypographyStyle} {
            font-weight: normal;
        }
    `,
};

locationSearchFormStyles.pagination = {
    cssOverrides: {
        pagination: css`
            justify-content: flex-end;
            width: 100%;
        `,
        perPageSelect: css`
            display: none;
        `,
    },
};

locationSearchFormStyles.locationAddressInfoCondensed = {
    wrapper: {
        css: css`
            line-height: 19px;
        `,
    },
};
